import React, { useEffect } from 'react';
import { useFeatureFlags } from 'components/context/feature_flags';
import { useTranslation } from 'react-i18next';
import { FOOTNOTE_SYMBOL } from 'components/common/banners/banner_helpers';

const IssuerInstallmentsPrice = ({ issuerInstallmentsDetails }) => {
  const {
    quote_payments_amount: paymentAmount = '',
    quote_number_of_payments: paymentPeriodsNumber = 0,
  } = issuerInstallmentsDetails || {};

  const { t, i18n } = useTranslation();
  const { issuerInstallmentsEnabled } = useFeatureFlags();

  if (!paymentAmount || !paymentPeriodsNumber || !issuerInstallmentsEnabled) {
    return null;
  }

  useEffect(() => {
    const disclaimerKey = 'productPage.issuerInstallmentsDisclaimer';
    const disclaimer = `${FOOTNOTE_SYMBOL.asteriskSingle} ${t(disclaimerKey)}`;

    if (
      Sq.SqShopFooter &&
      i18n.exists(disclaimerKey) &&
      !Sq.SqShopFooter.disclaimers.includes(disclaimer)
    ) {
      Sq.SqShopFooter.disclaimers = [
        ...Sq.SqShopFooter.disclaimers,
        disclaimer,
      ];
    }
  }, []);

  return (
    <span data-testid="issuer-installments-price-component">
      {t('productPage.issuerInstallmentsPrice', {
        paymentAmount,
        paymentPeriodsNumber,
      })}
    </span>
  );
};

export default IssuerInstallmentsPrice;
